window.affix = {
  sass:{
    boxPadding: EASY.getSassData('box-padding', 24, true)
  },
  register: [],
  enabled: {
    tableScrollbars: false,
    sidebar: false,
    formActions: false
  },
  prepareHeads: function ($theads) {
    const justifyContentValMap = {
      right: "flex-end",
      center: "center",
      left: "flex-start",
    };

    $theads.each(function () {
      let css = [];
      const $this = $(this);

      if (affix.headsAlreadyPrepared($this)) return;

      const $rows = $this.find('tr');
      $rows.each(function () {
        const $this = $(this);
        const $parent = $this.parent();
        const $cells = $this.find('th,td');
        const LAST_SORTABLE_BUTTON_CLICKED_KEY = 'lastSortableButtonClicked';

        $cells.each(function (index) {
          const $this = $(this);
          const hasDataSortableAttr = $this[0].dataset.sortable;
          const columnId = $this[0].dataset.resizableColumnId;

          if (hasDataSortableAttr) {
            $this.find('a').ready(function() {
              const sortableKey = window.sessionStorage.getItem(LAST_SORTABLE_BUTTON_CLICKED_KEY);
              const parsedSortableKey = JSON.parse(sortableKey);
              if (parsedSortableKey && columnId === parsedSortableKey) {
                $this.find('a').focus();
                window.sessionStorage.removeItem(LAST_SORTABLE_BUTTON_CLICKED_KEY);
              };
            });
            $this.on('click',function () {
              if (columnId) window.sessionStorage.setItem(LAST_SORTABLE_BUTTON_CLICKED_KEY, JSON.stringify(columnId));
            });
          }
          css[index] = {
            paddingTop: $this.css("paddingTop"),
            paddingRight: $this.css("paddingRight"),
            paddingBottom: $this.css("paddingBottom"),
            paddingLeft: $this.css("paddingLeft"),
            textAlign: $this.css("textAlign"),
          };
        });

        $this.detach();
        $cells.each(function (index) {
          const $this = $(this);
          const html = $this.html()
          $this.find('a').attr('aria-hidden','true').attr('inert','');
          $this.append(`
            <div class="affix-cell-wrap" style="padding: ${css[index].paddingTop}
                                                         ${css[index].paddingRight}
                                                         ${css[index].paddingBottom}
                                                         ${css[index].paddingLeft};
                                                justify-content: ${justifyContentValMap[css[index].textAlign]};
                                                z-index: 4;">
              ${html}
            </div>
          `);
          $this.find('.affix-cell-wrap .editable-parent span.icon-edit').remove();
        });
        $parent.append($this);
      });
    });
    return $theads;
  },
  recalculateHeads: function ($theads) {
    return;
  },
  preInit: function () {
    affix.register['main'] = false;
    affix.register['document'] = false;
    affix.register['topMenu'] = false;
    affix.register['sidebar'] = false;
    affix.register['tableScrolls'] = false;
    affix.register['tableHeads'] = false;
    // affix.register['formActions'] = false;
    affix.prepareHeads(ERUI.tableHeads);
    $(document).on("erui_interface_change_horizontal", function () {
      affix.recalculateHeads(ERUI.tableHeads);
    });
    affix.init(true);
  },
  reInit: function () {
    affix.init(false);
  },
  init: function (reset) {
    affix.register['window'] = {height: window.innerHeight};
    if (!$.fx.off && !ERUI.isMobile) {
      if (ERUI.main && ERUI.main.length > 0) {
        let main = {
          element: ERUI.main,
          position: ERUI.main[0].getBoundingClientRect(),
          scroll: 0
        };
        affix.register['main'] = main;
      }

      if (ERUI.content && ERUI.content.length > 0) {
        let content = {
          element: ERUI.content,
          position: ERUI.content[0].getBoundingClientRect(),
          scroll: 0
        };
        affix.register['content'] = content;
      }

      if (ERUI.html && ERUI.html.length > 0) {
        let document = {
          element: ERUI.html,
          position: ERUI.html[0].getBoundingClientRect(),
          scroll: 0
        };
        affix.register['document'] = document;
      }

      if (ERUI.topMenu && ERUI.topMenu.length > 0) {
        let topMenu = {};
        topMenu.element = ERUI.topMenu;
        topMenu.position = topMenu.element[0].getBoundingClientRect();
        affix.register['topMenu'] = topMenu;
      }

      if (ERUI.header && ERUI.header.length > 0) {
        let header = {};
        header.element = ERUI.header;
        header.position = header.element[0].getBoundingClientRect();
        affix.register['header'] = header;
        affix.register['headerHeight'] = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--easy__header-height'), 10);;
      }

      // if (ERUI.tableScrolls && ERUI.tableScrolls.length > 0) {
      //   this.initTablescrolls(ERUI.tableScrolls, reset);
      // }

      if (ERUI.tableHeads && ERUI.tableHeads.length > 0) {
        this.initTableheads(ERUI.tableHeads,reset);
      }
    }
  },
  initTablescrolls: function(scrolls, reset){
    // let tableScrolls = {};
    // tableScrolls.wrappers = {};
    // tableScrolls.xbars = {};
    // tableScrolls.wrappers.element = scrolls;
    // tableScrolls.wrappers.position = [];
    // tableScrolls.xbars.element = [];
    // tableScrolls.xbars.position = [];
    // tableScrolls.xbars.element = tableScrolls.wrappers.element.children(".ps__rail-x");
    // tableScrolls.wrappers.element.each(function (index) {
    //   tableScrolls.wrappers.position[index] = tableScrolls.wrappers.element[index].getBoundingClientRect();
    //   tableScrolls.xbars.position[index] = tableScrolls.xbars.element[index].getBoundingClientRect();
    //
    //   if (affix.register['tableScrolls']) {
    //     const register = affix.register['tableScrolls'].wrappers.element;
    //     const node = tableScrolls.wrappers.element[index];
    //     const registered = register.is(node);
    //     if(!registered) {
    //       affix.register['tableScrolls'].wrappers.element.push(tableScrolls.wrappers.element[index]);
    //       affix.register['tableScrolls'].wrappers.position.push(tableScrolls.wrappers.position[index]);
    //       affix.register['tableScrolls'].xbars.element.push(tableScrolls.xbars.element[index]);
    //       affix.register['tableScrolls'].xbars.position.push(tableScrolls.xbars.position[index]);
    //     }
    //   }
    // });
    // if (reset) {
    //   tableScrolls.xbars.element.css({
    //     willChange: 'transform',
    //     MsTransform: 'translate(0,0)',
    //     WebkitTransform: 'translate(0,0)',
    //     transform: 'translate(0,0)'
    //   });
    // }
    // if (!affix.register['tableScrolls']) {
    //   affix.register['tableScrolls'] = tableScrolls;
    // }
  },
  initTableheads: function(heads,reset){
    let tableHeads = {};
    tableHeads.element = heads;
    tableHeads.parent = {};
    tableHeads.fake = {};
    tableHeads.position = [];
    tableHeads.parent.element = [];
    tableHeads.parent.position = [];
    tableHeads.fake.elements = [];
    tableHeads.element.each(function (index) {
      if (tableHeads.element[index].parentNode === null) {
        return;
      }
      tableHeads.parent.element[index] = tableHeads.element[index].parentNode;
      tableHeads.position[index] = tableHeads.element[index].getBoundingClientRect();
      tableHeads.parent.position[index] = tableHeads.parent.element[index].getBoundingClientRect();
      tableHeads.fake.elements[index] = $(this).find('.affix-cell-wrap');
      if (reset) {
        tableHeads.fake.elements[index].each(function () {
          this.style.willChange = 'transform';
          this.style.MsTransform = 'translate(0,0)';
          this.style.WebkitTransform = 'translate(0,0)';
          this.style.transform = 'translate(0,0)';
        });
      }

      if (affix.register['tableHeads']) {
        const register = affix.register['tableHeads'].element;
        const node = tableHeads.element[index];
        const registered = register.is(node);
        if(!registered) {
          affix.register['tableHeads'].element.push(tableHeads.element[index]);
          affix.register['tableHeads'].fake.elements.push(tableHeads.fake.elements[index]);
          affix.register['tableHeads'].parent.element.push(tableHeads.parent.element[index]);
          affix.register['tableHeads'].parent.position.push(tableHeads.parent.position[index]);
          affix.register['tableHeads'].position.push(tableHeads.position[index]);
        }
      }
    });
    if (!affix.register['tableHeads']) {
      affix.register['tableHeads'] = tableHeads;
    }
  },
  read: function () {
    const sidebar = affix.register['sidebar'];
    if (sidebar && sidebar.fix.element) {
      sidebar.position = sidebar.element[0].getBoundingClientRect();
      sidebar.fix.position = sidebar.fix.element[0].getBoundingClientRect();
      sidebar.fix.parent.position = sidebar.fix.parent.element[0].getBoundingClientRect();
    } else {
      affix.enabled.sidebar = false;
    }

    const tableScrolls = affix.register['tableScrolls'];
    if (tableScrolls && tableScrolls.wrappers.element) {
      tableScrolls.wrappers.element.each(function (index) {
        tableScrolls.wrappers.position[index] = tableScrolls.wrappers.element[index].getBoundingClientRect();
      });
    }
    const tableHeads = affix.register['tableHeads'];
    if (tableHeads && tableHeads.element) {
      tableHeads.element.each(function (index) {
        if (tableHeads.parent.element[index] === undefined)
          return;
        tableHeads.position[index] = tableHeads.element[index].getBoundingClientRect();
        tableHeads.parent.position[index] = tableHeads.parent.element[index].getBoundingClientRect();
      });
    }
  },
  tableScrolls: function () {
    const tableScrolls = affix.register['tableScrolls'];
    if (tableScrolls) {
      const scroller = affix.register['window'];
      tableScrolls.xbars.element.each(function (index) {
        const wrapperPosition = tableScrolls.wrappers.position[index];
        if(!wrapperPosition) return;
        const formBottomDistance = -1 * (scroller.height + 1 - wrapperPosition.top - wrapperPosition.height);
        if (formBottomDistance > 0) {
          this.style.MsTransform = 'translate(0,' + (-formBottomDistance) + 'px)';
          this.style.WebkitTransform = 'translate(0,' + (-formBottomDistance) + 'px)';
          this.style.transform = 'translate(0,' + (-formBottomDistance) + 'px)';
        } else {
          this.style.MsTransform = 'translate(0,0)';
          this.style.WebkitTransform = 'translate(0,0)';
          this.style.transform = 'translate(0,0)';
        }
      });
    }
  },
  tableHeads: function () {
    const tableHeads = affix.register['tableHeads'];
    if (tableHeads) {
      let mh = 0;
      if (affix.register['topMenu']) {
        const menuPosition = affix.register['topMenu'].position;
        mh = menuPosition.height;
        if (affix.register['header']) {
          mh = menuPosition.height + affix.register['headerHeight'];
        }
      } else {
        mh = affix.register['content'] ? affix.register['content'].offsetTop : 0;
      }
      const pageTabs = document.getElementById('easy_page_tabs');
      if (pageTabs && pageTabs.offsetParent !== null) {
        mh += pageTabs.getBoundingClientRect().height;
      }
      tableHeads.element.each(function (index) {
        const wrapperPosition = tableHeads.parent.position[index];
        const formTopDistance = mh - wrapperPosition.top - 1;
        if (
          wrapperPosition.top < mh &&
          wrapperPosition.top + wrapperPosition.height - 2 * tableHeads.position[index].height > mh
        ) {
          tableHeads.fake.elements[index].each(function () {
            this.style.MsTransform = 'translate(0,' + (formTopDistance) + 'px)';
            this.style.WebkitTransform = 'translate(0,' + (formTopDistance) + 'px)';
            this.style.transform = 'translate(0,' + (formTopDistance) + 'px)';
            //this.style.opacity = '1';
          });
        } else {
          tableHeads.fake.elements[index].each(function () {
            this.style.MsTransform = 'translate(0,0)';
            this.style.WebkitTransform = 'translate(0,0)';
            this.style.transform = 'translate(0,0)';
            //this.style.opacity = '0';
          });
        }
      });
    }
  },
  headsAlreadyPrepared: function ($thead) {
    return $thead?.find(".affix-cell-wrap").length > 0;
  },
};
